<template><div><h1>页面切换显示loading</h1>
<p>移动端如果使用异步组件加载那么还是需要一点等待时间的，在网络慢时等待时间会更长。显示<code>Loading</code>状态缓解一下用户等待情绪就十分重要。</p>
<p>如果你使用<code>vue-router</code>和<code>vuex</code>，那么可以很容易实现。</p>
<p>首先，注册一个<code>module</code>来保存状态</p>
<pre class="hljs"><code><span class="hljs-keyword">const</span> store = <span class="hljs-keyword">new</span> Vuex.Store({}) <span class="hljs-comment">// 这里你可能已经有其他 module</span>

store.registerModule(<span class="hljs-string">'vux'</span>, { <span class="hljs-comment">// 名字自己定义</span>
  state: {
    <span class="hljs-attr">isLoading</span>: <span class="hljs-literal">false</span>
  },
  <span class="hljs-attr">mutations</span>: {
    updateLoadingStatus (state, payload) {
      state.isLoading = payload.isLoading
    }
  }
})
</code></pre>
<p>然后使用<code>vue-router</code>的<code>beforeEach</code>和<code>afterEach</code>来更改<code>loading</code>状态</p>
<pre class="hljs"><code>router.beforeEach(<span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">to, from, next</span>) </span>{
  store.commit(<span class="hljs-string">'updateLoadingStatus'</span>, {<span class="hljs-attr">isLoading</span>: <span class="hljs-literal">true</span>})
  next()
})

router.afterEach(<span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">to</span>) </span>{
  store.commit(<span class="hljs-string">'updateLoadingStatus'</span>, {<span class="hljs-attr">isLoading</span>: <span class="hljs-literal">false</span>})
})
</code></pre>
<p>在<code>App.vue</code>里使用<code>loading</code>组件并从<code>vuex</code>获取<code>isLoading</code>状态</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">loading</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"isLoading"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">loading</span>&gt;</span>
</code></pre>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Loading } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
<span class="hljs-keyword">import</span> { mapState } <span class="hljs-keyword">from</span> <span class="hljs-string">'vuex'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">components</span>: {
    Loading
  },
  <span class="hljs-attr">computed</span>: {
    ...mapState({
      <span class="hljs-attr">isLoading</span>: <span class="hljs-function"><span class="hljs-params">state</span> =&gt;</span> state.vux.isLoading
    })
  }
}
</code></pre>
<p>done.</p>
<p>如果你觉得在加载比较快时<code>Loading</code>组件一闪而过体验也不大好，那么你可以延迟设置<code>loading=false</code>。</p>
</div></template><script>
export default {
  head: {"title":"页面切换时显示loading | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vue-show-loading-163.vue?074973d3